export default "__VITE_ASSET__BNNakcMS__"